import { Suspense, useState, useEffect } from 'react';
import PageLoader from './PageLoader'; // Assuming PageLoader exists

/**
 * DelayedSuspense prevents the generic spinner from flashing if a JS chunk loads instantly (under 200ms).
 * Ideal for Million-User grade UX.
 */
const DelayedFallback = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;
  
  return <PageLoader text="Loading..." />;
};

export const DelayedSuspense = ({ children }: { children: React.ReactNode }) => {
  return (
    <Suspense fallback={<DelayedFallback />}>
      {children}
    </Suspense>
  );
};
